export const UNITS = {
  REQUEST: 'StatementOfRequirements/GetUnits/Request',
  SUCCESS: 'StatementOfRequirements/GetUnits/Success',
  FAILURE: 'StatementOfRequirements/GetUnits/Failure'
};
export const UNIT = {
  REQUEST: 'StatementOfRequirements/GetUnit/Request',
  SUCCESS: 'StatementOfRequirements/GetUnit/Success',
  FAILURE: 'StatementOfRequirements/GetUnit/Failure',
  RESET: 'StatementOfRequirements/GetUnit/Reset'
};
export const ADD = {
  REQUEST: 'StatementOfRequirements/AddUnit/Request',
  SUCCESS: 'StatementOfRequirements/AddUnit/Success',
  FAILURE: 'StatementOfRequirements/AddUnit/Failure'
};
export const UPDATE = {
  REQUEST: 'StatementOfRequirements/UpdateUnit/Request',
  SUCCESS: 'StatementOfRequirements/UpdateUnit/Success',
  FAILURE: 'StatementOfRequirements/UpdateUnit/Failure'
};
export const UNITSTATICDATA = {
  REQUEST: 'StatementOfRequirements/GetUnitStaticData/Request',
  SUCCESS: 'StatementOfRequirements/GetUnitStaticData/Success',
  FAILURE: 'StatementOfRequirements/GetUnitStaticData/Failure'
};
export const REMOVE = {
  REQUEST: 'StatementOfRequirements/RemoveUnit/Request',
  SUCCESS: 'StatementOfRequirements/RemoveUnit/Success',
  FAILURE: 'StatementOfRequirements/RemoveUnit/Failure'
};
export const FINANCE = {
  REQUEST: 'StatementOfRequirements/GetFinanceData/Request',
  SUCCESS: 'StatementOfRequirements/GetFinanceData/Success',
  FAILURE: 'StatementOfRequirements/GetFinanceData/Failure'
};
export const UPDATEFINANCEDATA = {
  REQUEST: 'StatementOfRequirements/UpdateFinanceData/Request',
  SUCCESS: 'StatementOfRequirements/UpdateFinanceData/Success',
  FAILURE: 'StatementOfRequirements/UpdateFinanceData/Failure'
};
export const WHOCANCONFIRMSOR = {
  REQUEST: 'StatementOfRequirements/WhoCanConfirmSor/Request',
  SUCCESS: 'StatementOfRequirements/WhoCanConfirmSor/Success',
  FAILURE: 'StatementOfRequirements/WhoCanConfirmSor/Failure'
};
export const PHASECHANGE = {
  REQUEST: 'StatementOfRequirements/PhaseChange/Request',
  SUCCESS: 'StatementOfRequirements/PhaseChange/Success',
  FAILURE: 'StatementOfRequirements/PhaseChange/Failure'
};
export const CLEARFINANCEDATA = {
  SUCCESS: 'StatementOfRequirements/ClearFinanceData/Success',
  FAILURE: 'StatementOfRequirements/ClearFinanceData/Failure'
};
export const GET = {
  REQUEST: 'StatementOfRequirements/Get/Request',
  SUCCESS: 'StatementOfRequirements/Get/Success',
  FAILURE: 'StatementOfRequirements/Get/Failure'
};
export const CONFIRM = {
  REQUEST: 'StatementOfRequirements/Confirm/Request',
  SUCCESS: 'StatementOfRequirements/Confirm/Success',
  FAILURE: 'StatementOfRequirements/Confirm/Failure'
};
export const EXPORT = {
  REQUEST: 'StatementOfRequirements/ExportSor/Request',
  SUCCESS: 'StatementOfRequirements/ExportSor/Success',
  FAILURE: 'StatementOfRequirements/ExportSor/Failure'
};
export const GET_SOR_SR = {
  REQUEST: 'StatementOfRequirements/ServiceRequest/Request',
  SUCCESS: 'StatementOfRequirements/ServiceRequest/Success',
  FAILURE: 'StatementOfRequirements/ServiceRequest/Failure'
};
export const GETSORPARTY = {
  REQUEST: 'StatementOfRequirements/GetSorParty/Request',
  SUCCESS: 'StatementOfRequirements/GetSorParty/Success',
  FAILURE: 'StatementOfRequirements/GetSorParty/Failure'
};
export const CLEAR_SOR_PARTY = {
  SUCCESS: 'StatementOfRequirements/ClearSorParty/Success'
};
export const SUMMARY = {
  REQUEST: 'StatementOfRequirements/Summary/Request',
  SUCCESS: 'StatementOfRequirements/Summary/Success',
  FAILURE: 'StatementOfRequirements/Summary/Failure'
};
export const CONFIRM_ISOR = {
  REQUEST: 'StatementOfRequirements/ConfirmIsor/Request',
  SUCCESS: 'StatementOfRequirements/ConfirmIsor/Success',
  FAILURE: 'StatementOfRequirements/ConfirmIsor/Failure'
};
export const CANCREATESERVICEREQUEST = {
  REQUEST: 'StatementOfRequirements/CanCreateServiceRequest/Request',
  SUCCESS: 'StatementOfRequirements/CanCreateServiceRequest/Success',
  FAILURE: 'StatementOfRequirements/CanCreateServiceRequest/Failure'
};
export const CONFIRM_FSOR = {
  REQUEST: 'StatementOfRequirements/ConfirmFsor/Request',
  SUCCESS: 'StatementOfRequirements/ConfirmFsor/Success',
  FAILURE: 'StatementOfRequirements/ConfirmFsor/Failure'
};
export const VALIDATE_CONFIRM_FSOR = {
  REQUEST: 'StatementOfRequirements/ValidateConfirmFsor/Request',
  SUCCESS: 'StatementOfRequirements/ValidateConfirmFsor/Success',
  FAILURE: 'StatementOfRequirements/ValidateConfirmFsor/Failure'
};
export const FREEZE = {
  REQUEST: 'StatementOfRequirements/Freeze/Request',
  SUCCESS: 'StatementOfRequirements/Freeze/Success',
  FAILURE: 'StatementOfRequirements/Freeze/Failure'
};
export const UPDATE_ALL_SORS_FROZEN_STATE = {
  REQUEST: 'StatementOfRequirements/Frozen/Request',
  SUCCESS: 'StatementOfRequirements/Frozen/Success',
  FAILURE: 'StatementOfRequirements/Frozen/Failure'
};
